// @ts-nocheck
/**
 * Utility functions to generate random lottery data for Venezuelan lotteries
 * All results are generated for today's date
 */

// Venezuelan animals for "Animalitos"
const ANIMALS = [
  {number: "00", name: "Delfín"},
  {number: "01", name: "Carnero"},
  {number: "02", name: "Toro"},
  {number: "03", name: "Ciempiés"},
  {number: "04", name: "Alacrán"},
  {number: "05", name: "León"},
  {number: "06", name: "Rana"},
  {number: "07", name: "Perico"},
  {number: "08", name: "Ratón"},
  {number: "09", name: "Águila"},
  {number: "10", name: "Tigre"},
  {number: "11", name: "Gato"},
  {number: "12", name: "Caballo"},
  {number: "13", name: "Mono"},
  {number: "14", name: "Paloma"},
  {number: "15", name: "Zorro"},
  {number: "16", name: "Oso"},
  {number: "17", name: "Pavo"},
  {number: "18", name: "Burro"},
  {number: "19", name: "Chivo"},
  {number: "20", name: "Cochino"},
  {number: "21", name: "Gallo"},
  {number: "22", name: "Camello"},
  {number: "23", name: "Cebra"},
  {number: "24", name: "Iguana"},
  {number: "25", name: "Gallina"},
  {number: "26", name: "Vaca"},
  {number: "27", name: "Perro"},
  {number: "28", name: "Zamuro"},
  {number: "29", name: "Elefante"},
  {number: "30", name: "Caimán"},
  {number: "31", name: "Lapa"},
  {number: "32", name: "Ardilla"},
  {number: "33", name: "Pescado"},
  {number: "34", name: "Venado"},
  {number: "35", name: "Jirafa"},
  {number: "36", name: "Culebra"},
];

// Venezuelan lottery names
const _LOTTERY_NAMES = [
  "Zulia 7:00 PM",
  "Zulia 12:30 PM",
  "Triple Táchira 12:30 PM",
  "Triple Táchira 4:30 PM",
  "Triple Táchira 7:30 PM",
  "Chance Táchira 1:00 PM",
  "Chance Táchira 4:30 PM",
  "Chance Táchira 7:00 PM",
  "Chance Animalitos 9:00 AM",
  "Chance Animalitos 10:00 AM",
  "Chance Animalitos 11:00 AM",
  "Chance Animalitos 12:00 PM",
  "Chance Animalitos 1:00 PM",
  "Chance Animalitos 2:00 PM",
  "Chance Animalitos 3:00 PM",
  "Chance Animalitos 4:00 PM",
  "Chance Animalitos 5:00 PM",
  "Chance Animalitos 6:00 PM",
  "Chance Animalitos 7:00 PM",
];

// Animalitos draw times
const ANIMALITOS_TIMES = [
  "09:00 AM",
  "10:00 AM",
  "11:00 AM",
  "12:00 PM",
  "01:00 PM",
  "02:00 PM",
  "03:00 PM",
  "04:00 PM",
  "05:00 PM",
  "06:00 PM",
  "07:00 PM",
];

/**
 * Get today's date formatted for display
 */
export const getTodayFormatted = () => {
  const today = new Date();
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return today.toLocaleDateString("es-VE", options);
};

/**
 * Get today's date in simple format
 */
export const getTodaySimple = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear();
  return `${day}/${month}/${year}`;
};

/**
 * Generate a random animal result
 */
export const generateRandomAnimal = () => {
  const randomIndex = Math.floor(Math.random() * ANIMALS.length);
  return ANIMALS[randomIndex];
};

/**
 * Generate random lottery numbers (3 or 4 digits)
 */
export const generateRandomLotteryNumber = (digits = 3) => {
  const max = digits === 3 ? 999 : 9999;
  const number = Math.floor(Math.random() * (max + 1));
  return String(number).padStart(digits, "0");
};

/**
 * Generate random serial number
 */
export const generateRandomSerial = () => {
  return String(Math.floor(Math.random() * 100)).padStart(2, "0");
};

/**
 * Generate animalitos results for all times of the day
 */
export const generateAnimalitosDayResults = () => {
  return ANIMALITOS_TIMES.map(time => ({
    time,
    result: generateRandomAnimal(),
    date: getTodaySimple(),
  }));
};

/**
 * Generate a lottery result
 */
export const generateLotteryResult = (name, time) => {
  return {
    name,
    time,
    numbers: [generateRandomLotteryNumber(3), generateRandomLotteryNumber(3), generateRandomLotteryNumber(3)],
    serial: generateRandomSerial(),
    date: getTodaySimple(),
  };
};

/**
 * Generate results for multiple lotteries
 */
export const generateLotteriesResults = () => {
  return [
    {
      name: "Zulia",
      time: "7:00 PM",
      numbers: [generateRandomLotteryNumber(3), generateRandomLotteryNumber(3), generateRandomLotteryNumber(3)],
      serial: generateRandomSerial(),
      date: getTodaySimple(),
    },
    {
      name: "Zulia",
      time: "12:30 PM",
      numbers: [generateRandomLotteryNumber(3), generateRandomLotteryNumber(3), generateRandomLotteryNumber(3)],
      serial: generateRandomSerial(),
      date: getTodaySimple(),
    },
    {
      name: "Triple Táchira",
      time: "12:30 PM",
      numbers: [generateRandomLotteryNumber(3), generateRandomLotteryNumber(3), generateRandomLotteryNumber(3)],
      serial: generateRandomSerial(),
      date: getTodaySimple(),
    },
    {
      name: "Triple Táchira",
      time: "4:30 PM",
      numbers: [generateRandomLotteryNumber(3), generateRandomLotteryNumber(3), generateRandomLotteryNumber(3)],
      serial: generateRandomSerial(),
      date: getTodaySimple(),
    },
    {
      name: "Triple Táchira",
      time: "7:30 PM",
      numbers: [generateRandomLotteryNumber(3), generateRandomLotteryNumber(3), generateRandomLotteryNumber(3)],
      serial: generateRandomSerial(),
      date: getTodaySimple(),
    },
    {
      name: "Chance Táchira",
      time: "1:00 PM",
      numbers: [generateRandomLotteryNumber(4)],
      serial: generateRandomSerial(),
      date: getTodaySimple(),
    },
    {
      name: "Chance Táchira",
      time: "4:30 PM",
      numbers: [generateRandomLotteryNumber(4)],
      serial: generateRandomSerial(),
      date: getTodaySimple(),
    },
    {
      name: "Chance Táchira",
      time: "7:00 PM",
      numbers: [generateRandomLotteryNumber(4)],
      serial: generateRandomSerial(),
      date: getTodaySimple(),
    },
  ];
};

/**
 * Get latest animalitos results (last 3 draws)
 */
export const getLatestAnimalitoResults = (count = 3) => {
  const allResults = generateAnimalitosDayResults();
  return allResults.slice(-count);
};

/**
 * Get latest lottery results (last 3 draws)
 */
export const getLatestLotteryResults = (count = 3) => {
  const allResults = generateLotteriesResults();
  return allResults.slice(-count);
};
